module.exports = __webpack_public_path__ + "img/06.c4dee542.png";